import Req from '../../req'
const actions = {
    getAgree: function (store, [cb]) {
        let data = {
            uid: store.rootState.user.uid,
            owcode: store.rootState.user.owcode,
            ver: store.rootState.agree_version
        }
        Req.userInfo.getAgree(data, cb);
    },
    setAgree: function (store, [cb]) {
        let data = {
            uid: store.rootState.user.uid,
            owcode: store.rootState.user.owcode,
            ver: store.rootState.agree_version,
            agree: 1
        }
        Req.userInfo.setAgree(data, cb);
    },
    feedback: function (store, [content, img_ids, type, cb]) {
        let data = {
            uid: store.rootState.user.uid,
            owcode: store.rootState.user.owcode,
            type: type,
            content: content,
            img_ids: img_ids,
        }
        Req.userInfo.feedback(data, cb);
    },
    userFile: function (store, [data, cb]) {
        Req.userInfo.userFile(data, cb);
    },
    userGrowthTake: function (store, [type, cb]) {
        let data = {
            uid: store.rootState.user.uid,
            owcode: store.rootState.user.owcode,
            type: type,
        }

        Req.userInfo.userGrowthTake(data, cb);
    },
    userSigninInfo: function (store, [cb]) {
        let data = {
            uid: store.rootState.user.uid,
            owcode: store.rootState.user.owcode,
        }
        Req.userInfo.userSigninInfo(data, cb);
    },
    userGrowthInfo: function (store, [cb]) {
        let data = {
            uid: store.rootState.user.uid,
            owcode: store.rootState.user.owcode,
        }
        Req.userInfo.userGrowthInfo(data, cb);
    },
    userPoints: function (store, [cb]) {
        let data = {
            uid: store.rootState.user.uid,
        }
        Req.userInfo.info(data, cb);
    },
    userPointsDays: function (store, [cb]) {
        let data = {
            uid: store.rootState.user.uid,
            count: 7 // 查询天数
        }
        Req.userInfo.points(data, cb);
    },
}
export default {
    namespaced: false,
    actions
}